import { FC, ReactNode } from 'react';
import { Box, Typography, useTheme } from '@material-ui/core';

type Props = {
  children?: ReactNode;
  title: string;
};

export const Label: FC<Props> = ({ title, children }) => {
  const theme = useTheme();
  return (
    <Box display="flex" flexDirection="column" style={{ gap: '4px' }}>
      <Typography
        style={{ color: theme.palette.secondary.dark, fontWeight: 600 }}
        variant="caption"
      >
        {title.toUpperCase()}
      </Typography>
      {children}
    </Box>
  );
};
